import { useTranslation } from "@redotech/redo-i18n";
import { memo } from "react";
import { WalkthroughHighlightStep } from "./walkthrough-highlight-step";
import { WalkthroughModalStep as WalkthroughModalStepComponent } from "./walkthrough-modal-step";
import { WalkthroughProgressBar } from "./walkthrough-progress-bar";
import {
  WalkthroughHighlightStep as HighlightStepType,
  WalkthroughModalStep as ModalStepType,
} from "./walkthrough-types";

export const WalkthroughOverlay = memo(function WalkthroughOverlay({
  step,
  stepIndex,
  totalSteps,
  next,
  back,
  dismiss,
}: {
  step: ModalStepType | HighlightStepType;
  stepIndex: number;
  totalSteps: number;
  next(): void;
  back(): void;
  dismiss(): void;
}) {
  const { t } = useTranslation();
  const progressBar = step.section ? (
    <WalkthroughProgressBar
      dismiss={dismiss}
      stepIndex={stepIndex}
      totalSteps={totalSteps}
    />
  ) : null;

  if (step.type === "modal") {
    return (
      <>
        {progressBar}
        <WalkthroughModalStepComponent
          back={back}
          next={next}
          step={step}
          stepIndex={stepIndex}
          totalSteps={totalSteps}
        />
      </>
    );
  }

  const resolvedStep: Omit<HighlightStepType, "title"> & { title: string } = {
    ...step,
    title: typeof step.title === "function" ? step.title(t) : step.title,
  };

  return (
    <>
      {progressBar}
      <WalkthroughHighlightStep
        back={back}
        next={next}
        step={resolvedStep}
        stepIndex={stepIndex}
        totalSteps={totalSteps}
      />
    </>
  );
});
